// getters
export const GETTERS_LIST_LEVEL = "GETTERS_LIST_LEVEL";

// actions
export const ACTIONS_SET_LEVEL_LIST = "ACTIONS_SET_LEVEL_LIST";
export const ACTIONS_SET_LEVEL_LIST_PURE = "ACTIONS_SET_LEVEL_LIST_PURE";
export const ACTION_SET_PROGRAM_LEVELS = "ACTION_SET_PROGRAM_LEVELS";

// mutations
export const MUTATIONS_SET_LEVEL_LIST = "MUTATIONS_SET_LEVEL_LIST";

// Level Reward static checkboxes
export const LEVEL_REWARD_CHECKBOXES = [
  {
    text: "Tobacco Surcharge",
    value: "TobaccoSurcharge"
  },
  {
    text: "Tobacco Payroll Credit",
    value: "TobaccoPayrollCredit"
  },
  {
    text: "Custom (Add Description)",
    value: "TobaccoCustom"
  },
  {
    text: "Gift card",
    value: "TangoCard"
  },
  {
    text: "Payroll Credits",
    value: "PayrollCredits"
  },
  {
    text: "Health Savings Account Contributions",
    value: "HealthSavings"
  },
  {
    text: "Paid Time Off",
    value: "PaidTimeOff"
  },
  {
    text: "Custom (Add Description)",
    value: "Custom"
  }
];



// WEBPACK FOOTER //
// ./src/store/modules/basic_levels/constants.js